import React, { createContext, useState } from 'react';

const WarehouseContext = createContext();

export const WarehouseProvider = ({ children }) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    console.log('WarehouseProvider selectedWarehouse:', selectedWarehouse);

  return (
    <WarehouseContext.Provider value={{ selectedWarehouse, setSelectedWarehouse }}>
      {children}
    </WarehouseContext.Provider>
  );
};

export default WarehouseContext;
